function _createForOfIteratorHelper(o, allowArrayLike) { var it = typeof Symbol !== "undefined" && o[Symbol.iterator] || o["@@iterator"]; if (!it) { if (Array.isArray(o) || (it = _unsupportedIterableToArray(o)) || allowArrayLike && o && typeof o.length === "number") { if (it) o = it; var i = 0; var F = function F() {}; return { s: F, n: function n() { if (i >= o.length) return { done: true }; return { done: false, value: o[i++] }; }, e: function e(_e) { throw _e; }, f: F }; } throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); } var normalCompletion = true, didErr = false, err; return { s: function s() { it = it.call(o); }, n: function n() { var step = it.next(); normalCompletion = step.done; return step; }, e: function e(_e2) { didErr = true; err = _e2; }, f: function f() { try { if (!normalCompletion && it.return != null) it.return(); } finally { if (didErr) throw err; } } }; }

function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

// Copyright (c) Microsoft Corporation.
// Licensed under the MIT license.
import { log } from "./log";
var debugEnvVariable = typeof process !== "undefined" && process.env && process.env.DEBUG || undefined;
var enabledString;
var enabledNamespaces = [];
var skippedNamespaces = [];
var debuggers = [];

if (debugEnvVariable) {
  enable(debugEnvVariable);
}

var debugObj = Object.assign(function (namespace) {
  return createDebugger(namespace);
}, {
  enable: enable,
  enabled: enabled,
  disable: disable,
  log: log
});

function enable(namespaces) {
  enabledString = namespaces;
  enabledNamespaces = [];
  skippedNamespaces = [];
  var wildcard = /\*/g;
  var namespaceList = namespaces.split(",").map(function (ns) {
    return ns.trim().replace(wildcard, ".*?");
  });

  var _iterator = _createForOfIteratorHelper(namespaceList),
      _step;

  try {
    for (_iterator.s(); !(_step = _iterator.n()).done;) {
      var ns = _step.value;

      if (ns.startsWith("-")) {
        skippedNamespaces.push(new RegExp("^".concat(ns.substr(1), "$")));
      } else {
        enabledNamespaces.push(new RegExp("^".concat(ns, "$")));
      }
    }
  } catch (err) {
    _iterator.e(err);
  } finally {
    _iterator.f();
  }

  var _iterator2 = _createForOfIteratorHelper(debuggers),
      _step2;

  try {
    for (_iterator2.s(); !(_step2 = _iterator2.n()).done;) {
      var instance = _step2.value;
      instance.enabled = enabled(instance.namespace);
    }
  } catch (err) {
    _iterator2.e(err);
  } finally {
    _iterator2.f();
  }
}

function enabled(namespace) {
  if (namespace.endsWith("*")) {
    return true;
  }

  var _iterator3 = _createForOfIteratorHelper(skippedNamespaces),
      _step3;

  try {
    for (_iterator3.s(); !(_step3 = _iterator3.n()).done;) {
      var skipped = _step3.value;

      if (skipped.test(namespace)) {
        return false;
      }
    }
  } catch (err) {
    _iterator3.e(err);
  } finally {
    _iterator3.f();
  }

  var _iterator4 = _createForOfIteratorHelper(enabledNamespaces),
      _step4;

  try {
    for (_iterator4.s(); !(_step4 = _iterator4.n()).done;) {
      var enabledNamespace = _step4.value;

      if (enabledNamespace.test(namespace)) {
        return true;
      }
    }
  } catch (err) {
    _iterator4.e(err);
  } finally {
    _iterator4.f();
  }

  return false;
}

function disable() {
  var result = enabledString || "";
  enable("");
  return result;
}

function createDebugger(namespace) {
  var newDebugger = Object.assign(debug, {
    enabled: enabled(namespace),
    destroy: destroy,
    log: debugObj.log,
    namespace: namespace,
    extend: extend
  });

  function debug() {
    if (!newDebugger.enabled) {
      return;
    }

    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    if (args.length > 0) {
      args[0] = "".concat(namespace, " ").concat(args[0]);
    }

    newDebugger.log.apply(newDebugger, args);
  }

  debuggers.push(newDebugger);
  return newDebugger;
}

function destroy() {
  var index = debuggers.indexOf(this);

  if (index >= 0) {
    debuggers.splice(index, 1);
    return true;
  }

  return false;
}

function extend(namespace) {
  var newDebugger = createDebugger("".concat(this.namespace, ":").concat(namespace));
  newDebugger.log = this.log;
  return newDebugger;
}

export default debugObj;